import React from 'react';
import Component from 'components/Index';
import {connect} from 'react-redux';
import * as UIActions from 'actions/UiActions';
import withRouter from 'utils/withRouter';
import {SCROLLING_ELEMENT} from 'constants';

const Container = withRouter(connect(
	(state, ownProps) => ({
		router: state.router,
		works: state.works.all,
		work: state.works.work,
		id: state.works.id,
		artists: state.artists,
		searchText: state.ui.searchText,
		page: ownProps.router?.params?.page || 1,
		scrollingElementId: SCROLLING_ELEMENT
	}),
	(dispatch, ownProps) => ({
		onSearchChange: searchText => {
			dispatch(UIActions.onSearchChange(searchText));
		},
		onPageChange: nextPage => {
			if (ownProps.navigate) {
				ownProps.navigate(`/search/${nextPage}`);
			}
		},
		navigateTo: (location) => {
			if (ownProps.navigate) {
				ownProps.navigate(location);
			}
		}
	})
)(Component));
export default Container;